import { memo } from "react";
import type { LoaderCommonProps } from "../types";
import { tokens } from "../styles/tokens";
import { Skeleton } from "./Skeleton";

export const DashboardLoader = memo(function DashboardLoader({
  animated = true,
  width = "100%",
  height,
  className,
}: LoaderCommonProps) {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        display: "flex",
        gap: tokens.spacing.md,
      }}
    >
      <div
        style={{
          width: 56,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          gap: tokens.spacing.sm,
          padding: tokens.spacing.sm,
          background: "#fff",
          borderRadius: tokens.radius,
          boxShadow: tokens.shadow,
        }}
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={`nav-${i}`} width="100%" height={32} animated={animated} />
        ))}
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: tokens.spacing.md }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: tokens.spacing.md,
          }}
        >
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={`kpi-${i}`}
              style={{
                background: "#fff",
                borderRadius: tokens.radius,
                boxShadow: tokens.shadow,
                padding: tokens.spacing.md,
                display: "flex",
                flexDirection: "column",
                gap: tokens.spacing.sm,
              }}
            >
              <Skeleton width="50%" height={12} animated={animated} />
              <Skeleton width="70%" height={28} animated={animated} />
              <Skeleton width="40%" height={10} animated={animated} />
            </div>
          ))}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: tokens.spacing.md,
            flex: 1,
          }}
        >
          {Array.from({ length: 2 }).map((_, i) => (
            <div
              key={`chart-${i}`}
              style={{
                background: "#fff",
                borderRadius: tokens.radius,
                boxShadow: tokens.shadow,
                padding: tokens.spacing.md,
                display: "flex",
                flexDirection: "column",
                gap: tokens.spacing.sm,
                minHeight: 180,
              }}
            >
              <Skeleton width="40%" height={16} animated={animated} />
              <Skeleton width="100%" height="100%" animated={animated} style={{ flex: 1, minHeight: 120 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
